






import { Component, Prop, Vue } from 'vue-property-decorator'
import { Icon } from '@alpha/ink'

@Component({
  components: {
    Icon
  }
})
export default class CollapseArrow extends Vue {
  @Prop({ required: true }) value!: boolean

  clicked () {
    this.$emit('input', !this.value)
  }
}
